export const formatPLGTipoOperacao = (tipoOperacao: string) => {
  if (tipoOperacao === 'VENDA_DIRETA_PRIMEIRO_ADQUIRENTE') {
    return 'Venda direta ao Primeiro Adquirente';
  }
  if (tipoOperacao === 'REPASSE_PARCEIRO') {
    return 'Repasse para parceiro, ou membro da cadeia produtiva, ou cooperado, ou mandatário';
  } else {
    return 'Sem Operação';
  }
};
